<a
  class="mt-4 flex w-full cursor-pointer flex-row items-center justify-between rounded-2xl rounded-bl-md border-2 border-opacity-50 p-2 pl-4 hover:opacity-80"
  [ngClass]="colorSchemes()"
  href="{{ openLink() }}"
  target="_blank">
  {{ value() }}
  <div>
    <pay-icon [size]="'md'" [shape]="IconNames.ChevronRight" />
  </div>
</a>
